import Layout from "../include/layout";
import { Button, Form, Modal } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import Select from 'react-select';
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { myroutes } from "../../routes/webroute";
import ClassesoptionsService from "../classesoptions/ClassesoptionsService";
import { useSelector } from "react-redux";
import Filarial from "../include/filarial";
import InscriptionsService from "./InscriptionsService";
import dayjs from "dayjs";
import $ from "jquery";
import Swal from "sweetalert2";
import ApprenantsService from "../apprenants/ApprenantsService";


export default function ListeInscrits() {
    const [currentSchoolYear, setCurrentSchoolYear] = useState(2023)
    const [classeoptions, setClasseOptions] = useState([])
    const [apprennants, setApprenants] = useState([])
    const [selectedClasseOption, setSelectedClasseOption] = useState(null)
    const token = useSelector(state => state.auth.token)
    const indexInscription = "0";
    const indexReinscription = "1";
    const [inscrits, setInscrits] = useState([])
    const navigate = useNavigate()

    const activeLink = "INSCRITION - REINSCRIPTION"


    // liste classe option
    //get liste classesoptions
    const fetchClassesoptions = async (id) => {
        await ClassesoptionsService.index(token).then((res) => {
            if (res.data.data.classesoptions.length > 0) {
                const options = res.data.data.classesoptions.map((options, index) => {
                    //console.log("data => "+ options.libelleClasseOption)
                    return { value: options.id, label: options.libelleClasseOption }
                })
                setClasseOptions(options)
                //console.log("liste classe option" +classeoptions)

            }
        }).catch(error => {
            console.log(error)
        })
    }

    // gestion changement classe option
    const onChangeClasseOption = (e) => {
        //let _data = { ...inscriptionApprenantForm };
        //_data['classe_option_id'] = e.value;
        //setInscriptionApprenantForm(_data);
        setSelectedClasseOption(e);
        //console.log(inscriptionApprenantForm)

    };

    

    const fetchInscrits = async () => {
        await InscriptionsService.index(token).then(response => {
            setInscrits(response.data.data.inscriptions)
            //console.log(response.data.data.inscriptions)
            //initialize datatable
            $(document).ready(function () {
                $('.data-table').DataTable();
            });

        }).catch(error => {
            console.log(error)
        })
    }


    const fetchApprenants = async () => {
        await ApprenantsService.index(token).then(response => {
           // console.log(response.data.data.apprenants)
            setApprenants(response.data.data.apprenants)
            $(document).ready(function () {
                $('.data-table').DataTable();
            });
        }).catch(error => {
            console.log(error)
        })
    }

    //Go to detail of inscrit
    const goToShow = (param) => {
        navigate(myroutes.inscription_details, { state: { id: param } })
    }

    //Go to edit page
    const goToEdit = (id) => {

    }

    //suppression d'un élément
    const onDelete = (param) => {
        //confirm action
        Swal.fire({
            icon: "warning",
            text: "Voulez-vous confirmer cette action ?",
            showCancelButton: true,
            cancelButtonText: "Non",
            confirmButtonText: "Oui",
            confirmButtonColor: "red"
        }).then(result => {
            if (result.isConfirmed) {
                InscriptionsService.delete(param, token).then((response) => {
                    //console.log(response.data)
                    if (response.data.status !== 200) {
                        Swal.fire({
                            icon: "error",
                            text: response.data.message
                        })
                    } else {
                        Swal.fire({
                            icon: "success",
                            text: response.data.message
                        })
                        fetchInscrits()
                    }
                }).catch(e => {
                    Swal.fire({
                        icon: "error",
                        text: e.message
                    })
                    console.log(e)
                })
            }
        })
    }

    useEffect(() => {
        fetchClassesoptions()
        fetchInscrits()
        fetchApprenants()
    }, [])

    return (
        <Layout>
            <div className="container-xxl flex-grow-1 container-p-y">
                {/**{ start fil d'arial }**/}
                <Filarial activeLink={activeLink} />

                {/** end fil d'arial */}

                {/** start search options */}

                <div className="card mt-2">
                    <div className="card-header p-3 m-0">
                        <div className="row">
                            <div className="col-4">
                                <label htmlFor="label" className="d-inline"><span className="text-warning">Filtrer par</span> &nbsp;Année scolaire :&nbsp;</label>
                                <Form.Control
                                    className="form-control w-50 d-inline"
                                    type="text"
                                    value={currentSchoolYear}
                                    placeholder="" name="annee"
                                />
                            </div>

                            <div className="col-4 text-center">
                                <label htmlFor="label" className="d-inline-flex">Classe Option : &nbsp;&nbsp;</label>
                                <Select
                                    options={classeoptions}
                                    className="d-inline-flex"
                                    onChange={(e) => onChangeClasseOption(e)}
                                    value={selectedClasseOption}
                                    required
                                    name="classe_option_id"
                                />
                            </div>
                            <div className="col-4 text-center">
                                <label htmlFor="label" className="d-inline-flex">Recherche par élève : &nbsp;&nbsp;</label>
                                <Select
                                    options={classeoptions}
                                    className="d-inline-flex w-50"
                                    //onChange={(e) => onChangeGenre(e,'apprenant')}
                                    value={selectedClasseOption}
                                    required
                                    name="classe_option_id"
                                />
                            </div>


                        </div>
                    </div>
                </div>
                {/** end search options */}

                <div className="row mt-3">
                    <div className="col-12">
                        <b>Imprimer :</b> <span><button type="button" className="btn btn-danger"><i className="fas fa-file-pdf"></i>&nbsp;PDF</button></span> &nbsp;&nbsp; <span><button type="button" className="btn btn-success"><i className="far fa-file-excel"></i> &nbsp;Excel</button></span>
                    </div>
                </div>
                <div className="card mt-3 p-0 text-white theme-bg-yello">
                    <div className="card-header p-3 m-0">
                        <div className="row">
                            <div className="col-12">
                                <div className="d-inline">
                                    <Link to={myroutes.inscription_create} state={{ parametre: 0 }} className="text-white fw-bold"><FontAwesomeIcon size="10px" icon="fa-solid fa-circle-plus" className="text-white" />&nbsp;&nbsp;Inscrire un nouvel apprenant </Link>
                                </div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <div className="d-inline">
                                    <Link to={myroutes.inscription_create} state={{ parametre: 1 }} className="text-white fw-bold"><FontAwesomeIcon icon="fa-solid fa-circle-plus" className="text-white" />&nbsp;&nbsp;Réinscrire un ancien apprenant </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Responsive Datatable */}
                <div className="card shadow-lg mt-3 px-3 pt-4">
                    <div className="card-datatable table-responsive px-0 pb-3 m-0 pl-0 pr-0">
                        <table className="dt-responsive table border-top data-table table-hover table-borderedx table-striped w-100 mt-0" >
                            <thead className="theme-bg-blue-white">
                                <tr className="">
                                    <th className="cell"><span className="theme-color-blue">Matricule</span></th>
                                    <th className="cell"><span className="theme-color-blue">Nom</span></th>
                                    <th className="cell"><span className="theme-color-blue">Prénoms</span></th>
                                    {/**<th className="cell"><span className="theme-color-blue">Contact</span></th> */}
                                    <th className="cell"><span className="theme-color-blue">Ddn</span></th>
                                    <th className="cell"><span className="theme-color-blue">Lieu Nais.</span></th>
                                    <th className="cell"><span className="theme-color-blue">Classe</span></th>
                                    <th className="cell"><span className="theme-color-blue">Type</span></th>
                                    <th className="cell"><span className="theme-color-blue">Date enreg.</span></th>
                                    <th className="cell"><span className="theme-color-blue">Action</span></th>
                                </tr>
                            </thead>
                            <tbody>
                                {apprennants.length > 0 && apprennants.map((item, index) => (
                                    <tr key={index}>
                                        <td><strong>{item.matriculeApprenant}</strong></td>
                                        <td>{item.inscriptions.personnes.nomPersonne}</td>
                                        <td>{item.inscriptions.personnes.prenomsPersonne}</td>
                                        {/**<td>{item.personnes.telephonePersonne}</td> */}
                                        <td>{dayjs(item.inscriptions.personnes.ddn).format("DD/MM/YYYY")}</td>
                                        <td>{item.inscriptions.personnes.lieuNaissance}</td>
                                        <td>{item.inscriptions.classes.libelleClasse}</td>
                                        <td><span className="fw-bold">{item.inscriptions.typesinscriptions.libelleTypeInscription}</span></td>
                                        <td>{dayjs(item.updatedAt).format("DD/MM/YYYY H:m:s")}</td>
                                        <td>
                                            <div className="d-flex">
                                                <Button className="btn btn-sm" variant="success" onClick={() => goToShow(item.id)}
                                                    title="Fiche">
                                                    <i className="fas fa-file"></i></Button> &nbsp;&nbsp;
                                                <Button className="btn btn-sm" variant="primary" onClick={() => goToEdit(item.id)}
                                                    title="Modifier">
                                                    <i className="fas fa-edit"></i></Button> &nbsp;&nbsp;

                                                <Button className="btn btn-sm" variant="danger" onClick={() => onDelete(item.id)}
                                                    title="Supprimer">
                                                    <i className="fas fa-trash"></i></Button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}                                
                            </tbody>
                        </table>
                    </div>
                </div>
                {/*/ Responsive Datatable */}
            </div>
        </Layout>
    )
};
